import React from "react";
import { Paper } from '@material-ui/core';
import {
  TableCell,
  TableHead,
  TableRow,
  Table,
  TableBody
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const searchData = this.props.searchData;
    const mappingData = this.props.mappingData;

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div style={{ padding: '20px', marginBottom: '8rem', maxWidth: '100%' }}>
          <h2 style={{ textAlign: 'center' }}>Transport Deduction Details Report</h2>
          <div style={{ margin: '8px 0' }} />
          <h3 style={{ textAlign: 'center' }}>{searchData.groupName} - {searchData.factoryName}</h3>
          <div style={{ margin: '8px 0' }} />
          <h3 style={{ textAlign: 'center' }}>Route: {searchData.routeName ? searchData.routeName : "All Routes"} </h3>
          <div style={{ margin: '8px 0' }} />
          <h3 style={{ textAlign: 'center' }}>{searchData.registrationNumber ? "Registration Number: " + searchData.registrationNumber : ""}</h3>
          <div style={{ margin: '8px 0' }} />
          <h3 style={{ textAlign: 'center' }}>{searchData.fromDate} To {searchData.toDate}</h3>
          <div style={{ margin: '8px 0' }} />
          <h3 style={{ textAlign: 'center' }}>{searchData.applicableMonth ? "Applicable Month:" + searchData.applicableMonth : ""}</h3>

<div style={{ overflowX: 'auto', marginTop: '16px' }}>
  <Table aria-label="styled table" style={{ minWidth: '900px', width: '100%' }}>
    <TableHead>
      <TableRow>
        {[
          { title: 'Date', width: '100px' },
          { title: 'Route', width: '120px' },
          { title: 'Registration Number', width: '150px' },
          { title: 'Customer Name', width: '160px' },
          { title: 'Transport Rate', width: '130px' },
          { title: 'Applicable Month', width: '130px' },
          { title: 'Amount (Rs.)', width: '120px' },
        ].map((col, index) => (
          <TableCell
            key={index}
            align="center"
            style={{
              fontWeight: 'bold',
              fontSize: '15px',
              padding: '4px 8px',
              border: '1px solid black',
              width: col.width,
            }}
          >
            {col.title}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

    <TableBody>
      {mappingData.map((row, i) => (
        <TableRow key={i}>
          <TableCell align="center" style={{ padding: '4px 8px', border: '1px solid black' }}>
            {new Date(row.transactionDate).toISOString().split('T')[0]}
          </TableCell>
          <TableCell align="left" style={{ padding: '4px 8px', border: '1px solid black' }}>
            {row.routeName}
          </TableCell>
          <TableCell align="left" style={{ padding: '4px 8px', border: '1px solid black' }}>
            {row.registrationNumber}
          </TableCell>
          <TableCell align="left" style={{ padding: '4px 8px', border: '1px solid black' }}>
            {row.customerName}
          </TableCell>
          <TableCell align="right" style={{ padding: '4px 8px', border: '1px solid black' }}>
            {row.transportRate?.toFixed(2)}
          </TableCell>
          <TableCell align="center" style={{ padding: '4px 8px', border: '1px solid black' }}>
            {row.applicableMonth}
          </TableCell>
          <TableCell align="right" style={{ padding: '4px 8px', border: '1px solid black' }}>
            {row.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </TableCell>
        </TableRow>
      ))}

      <TableRow>
        <TableCell
          colSpan={6}
          align="left"
          style={{ fontWeight: 'bold', fontSize: '15px', padding: '4px 8px', border: '1px solid black' }}
        >
          Total
        </TableCell>
        <TableCell
          align="right"
          style={{ fontWeight: 'bold', fontSize: '15px', padding: '4px 8px', border: '1px solid black' }}
        >
           {mappingData.reduce((sum, row) => sum + row.amount, 0).toLocaleString('en-US', { minimumFractionDigits: 2,maximumFractionDigits: 2,})}        
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</div>


          <div style={{ marginTop: '24px' }}>
            <h4 style={{ textAlign: 'center' }}>******* End of List *******</h4>
          </div>
        </div>
      </Paper>
    );
  }
}